import { render, staticRenderFns } from "./GuiaTissSadt.vue?vue&type=template&id=0c634185"
import script from "./GuiaTissSadt.vue?vue&type=script&lang=ts"
export * from "./GuiaTissSadt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports